/* MRV product gallery behaviour for <mrv-gallery> (markup: snippets/product__gallery.liquid).
   The element itself is defined by a small inline stub in sections/product__main.liquid so that
   el.go() exists before theme.js mounts Vue. product-detail calls go(featured_image.position - 1)
   on variant change; calls made before this file loads are queued and applied here. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canZoom = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)'); // phones and tablets

  function behavior(smooth) {
    return smooth && !reduceMotion.matches ? 'smooth' : 'auto';
  }

  function init(el) {
    if (el._mrvReady) return;
    var track = el.querySelector('[data-mrv-track]');
    if (!track) return;
    el._mrvReady = true;

    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-mrv-slide]'));
    var gotoButtons = Array.prototype.slice.call(el.querySelectorAll('[data-mrv-goto]'));
    var prev = el.querySelector('[data-mrv-prev]');
    var next = el.querySelector('[data-mrv-next]');
    var thumbs = el.querySelector('[data-mrv-thumbs]');
    var thumbsPrev = el.querySelector('[data-mrv-thumbs-prev]');
    var thumbsNext = el.querySelector('[data-mrv-thumbs-next]');
    var index = 0;
    var target = null; // slide a programmatic scroll is heading to
    var targetTimer = null;
    var ticking = false;

    function measured() {
      var w = track.clientWidth;
      return w ? Math.round(track.scrollLeft / w) : index;
    }

    function goTo(i, smooth) {
      var count = slides.length;
      i = ((i % count) + count) % count; // arrows wrap around, like the old loop slider
      target = i;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = null; }, 1000);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: behavior(smooth) });
      if (i !== index) {
        index = i;
        update();
      }
    }

    function syncThumbArrows() {
      if (!thumbs || !thumbsPrev || !thumbsNext) return;
      var scrollable = thumbs.scrollWidth - thumbs.clientWidth > 2;
      thumbsPrev.hidden = thumbsNext.hidden = !scrollable && thumbs.clientWidth > 0;
      thumbsPrev.disabled = thumbs.scrollLeft <= 4;
      thumbsNext.disabled = thumbs.scrollLeft + thumbs.clientWidth >= thumbs.scrollWidth - 4;
    }

    function update() {
      gotoButtons.forEach(function (btn) {
        var active = parseInt(btn.getAttribute('data-mrv-goto'), 10) === index;
        if (active) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
        // Keep the active thumbnail inside the 4-up strip
        if (active && thumbs && thumbs.contains(btn) && thumbs.clientWidth) {
          var item = btn.parentNode;
          var left = item.offsetLeft;
          if (left < thumbs.scrollLeft || left + item.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
            thumbs.scrollTo({ left: left, behavior: behavior(true) });
          }
        }
      });

      // Stop media that has scrolled out of view
      slides.forEach(function (slide, i) {
        if (i === index) return;
        var video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
        var embed = slide.querySelector('[data-mrv-embed]');
        if (embed && embed._poster && embed.querySelector('iframe')) embed.replaceChildren(embed._poster);
      });
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = measured();
        // While goTo() animates, ignore the in-between positions so the dots don't flicker
        if (target !== null) {
          if (i !== target) return;
          target = null;
        }
        if (i !== index) {
          index = i;
          update();
        }
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(index + 1, true); });
    gotoButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(parseInt(btn.getAttribute('data-mrv-goto'), 10), true); });
    });

    if (thumbs) {
      thumbs.addEventListener('scroll', syncThumbArrows, { passive: true });
      if (thumbsPrev) thumbsPrev.addEventListener('click', function () {
        thumbs.scrollBy({ left: -thumbs.clientWidth, behavior: behavior(true) });
      });
      if (thumbsNext) thumbsNext.addEventListener('click', function () {
        thumbs.scrollBy({ left: thumbs.clientWidth, behavior: behavior(true) });
      });
    }

    // Mouse drag on the main image (touch already swipes natively through scroll-snap)
    var drag = null;
    var dragEndTimer = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || slides.length < 2) return;
      if (e.target.closest('button, a, iframe, video')) return;
      drag = { x: e.clientX, left: track.scrollLeft, time: Date.now(), id: e.pointerId, moved: false };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        clearTimeout(dragEndTimer);
        track.setPointerCapture(drag.id);
        el.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.moved) return;
      var dx = e.clientX - d.x;
      var width = track.clientWidth || 1;
      var start = Math.round(d.left / width);
      var velocity = Math.abs(dx) / Math.max(1, Date.now() - d.time); // px per ms
      var dest = start;
      if (e.type === 'pointerup' && (Math.abs(dx) > width * 0.15 || velocity > 0.5)) dest = start + (dx < 0 ? 1 : -1);
      dest = Math.max(0, Math.min(slides.length - 1, dest)); // no wrap-around when dragging
      goTo(dest, true);
      // Keep snapping off until the settle animation has finished, then hand back to scroll-snap
      dragEndTimer = setTimeout(function () { el.classList.remove('is-dragging'); }, 450);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', function (e) { if (drag) endDrag(e); });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1, true); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0, true); }
      else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1, true); }
    });

    // Videos: YouTube/Vimeo load only when played
    el.addEventListener('click', function (e) {
      var play = e.target.closest('[data-mrv-play]');
      if (!play) return;
      var embed = play.closest('[data-mrv-embed]');
      var iframe = document.createElement('iframe');
      iframe.src = embed.getAttribute('data-mrv-embed');
      iframe.title = embed.getAttribute('data-mrv-embed-title') || 'Product video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      embed._poster = play;
      embed.replaceChildren(iframe);
    });

    // Hover zoom
    Array.prototype.forEach.call(el.querySelectorAll('[data-zoom-src]'), function (frame) {
      var layer = null;
      function position(e) {
        var r = frame.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        layer.style.backgroundPosition = x + '% ' + y + '%';
      }
      frame.addEventListener('mouseenter', function (e) {
        if (!canZoom.matches) return;
        if (!layer) {
          layer = document.createElement('span');
          layer.className = 'mrv-gallery__zoom-layer';
          layer.setAttribute('aria-hidden', 'true');
          layer.style.backgroundImage = 'url("' + frame.getAttribute('data-zoom-src') + '")';
          frame.appendChild(layer);
        }
        position(e);
        frame.classList.add('is-zooming');
      });
      frame.addEventListener('mousemove', function (e) {
        if (layer && frame.classList.contains('is-zooming')) position(e);
      });
      frame.addEventListener('mouseleave', function () { frame.classList.remove('is-zooming'); });
    });

    // Keep the current slide in place when the width changes (rotation, resize, breakpoint)
    var resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'auto' });
        syncThumbArrows();
      });
      resizeObserver.observe(track);
    }

    // Called by product-detail as $refs.main.go(imagePosition - 1)
    el._mrvGoToImage = function (imageIndex) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-index') === String(imageIndex)) {
          goTo(i, el._mrvInteractive);
          return;
        }
      }
    };
    initViewer(el, function (imageIndex) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-index') === String(imageIndex)) { goTo(i, false); return; }
      }
    });
    el._mrvCleanup = function () {
      if (resizeObserver) resizeObserver.disconnect();
    };

    syncThumbArrows();
    update();
    // Vue's first go() (initial variant) lands without animation; later ones animate
    el._mrvInteractive = false;
    if (el._mrvPending !== undefined) el._mrvGoToImage(el._mrvPending);
    setTimeout(function () { el._mrvInteractive = true; }, 1000);
  }


  /* ---------- Full-screen viewer (touch devices only) ----------
     Tap the main image to open. One finger swipes between images (or pans when zoomed), two
     fingers pinch-zoom, double-tap toggles 2.5x. Back gesture / button closes (history entry). */
  var MAX_SCALE = 4;
  var DOUBLE_TAP_SCALE = 2.5;

  function initViewer(el, syncGallery) {
    var box = el.querySelector('[data-mrv-viewer]');
    if (!box || typeof box.showModal !== 'function') return;
    var stage = box.querySelector('[data-mrv-viewer-stage]');
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-mrv-viewer-item]'));
    var counter = box.querySelector('[data-mrv-viewer-index]');
    var prevBtn = box.querySelector('[data-mrv-viewer-prev]');
    var nextBtn = box.querySelector('[data-mrv-viewer-next]');
    var current = 0;
    var view = { s: 1, x: 0, y: 0 }; // transform of the current image
    var pointers = {};
    var gesture = null;
    var lastTap = null;
    var historyPushed = false;

    function img(i) { return items[i].querySelector('img'); }
    function stageRect() { return stage.getBoundingClientRect(); }

    function apply(animate) {
      var item = items[current];
      item.classList.toggle('is-animating', !!animate);
      img(current).style.transform = 'translate(' + view.x + 'px,' + view.y + 'px) scale(' + view.s + ')';
      box.classList.toggle('is-zoomed', view.s > 1.01);
    }

    // Keep a zoomed image covering the stage: no empty gaps at the edges
    function clamp() {
      var image = img(current);
      var r = stageRect();
      var maxX = Math.max(0, (image.offsetWidth * view.s - r.width) / 2);
      var maxY = Math.max(0, (image.offsetHeight * view.s - r.height) / 2);
      view.x = Math.max(-maxX, Math.min(maxX, view.x));
      view.y = Math.max(-maxY, Math.min(maxY, view.y));
    }

    // Zoom to scale s keeping the stage point (px, py) (relative to the stage centre) still
    function zoomAt(s, px, py) {
      s = Math.max(1, Math.min(MAX_SCALE, s));
      view.x = px - (px - view.x) * (s / view.s);
      view.y = py - (py - view.y) * (s / view.s);
      view.s = s;
    }

    function show(i, direction) {
      var count = items.length;
      i = Math.max(0, Math.min(count - 1, i));
      items.forEach(function (item, n) {
        item.hidden = n !== i;
        item.style.transform = '';
        item.classList.remove('is-animating');
        if (Math.abs(n - i) <= 1) img(n).loading = 'eager'; // current + neighbours
      });
      if (current !== i) img(current).style.transform = '';
      current = i;
      view = { s: 1, x: 0, y: 0 };
      apply(false);
      if (direction) {
        // Slide the new image in from the side it came from
        var item = items[i];
        item.style.transform = 'translateX(' + (direction * 40) + 'px)';
        item.offsetWidth; // flush
        item.classList.add('is-animating');
        item.style.transform = '';
      }
      if (counter) counter.textContent = String(i + 1);
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= count - 1;
    }

    function open(imageIndex) {
      show(imageIndex || 0);
      document.documentElement.style.overflow = 'hidden';
      box.showModal();
      box.classList.remove('hint-done');
      setTimeout(function () { box.classList.add('hint-done'); }, 2500);
      try { history.pushState({ mrvViewer: true }, ''); historyPushed = true; } catch (e) { historyPushed = false; }
    }

    // Cleanup for every way of closing (button, Esc, Android back, iOS back swipe, browser)
    function cleanup() {
      document.documentElement.style.overflow = '';
      pointers = {};
      gesture = null;
      syncGallery(current);
    }
    function finishClose() {
      if (box.open) box.close();
      cleanup();
    }
    function requestClose() {
      if (historyPushed) { history.back(); } // popstate below finishes the close
      else finishClose();
    }
    window.addEventListener('popstate', function () {
      if (!historyPushed) return;
      historyPushed = false;
      finishClose();
    });
    box.addEventListener('cancel', function (e) { e.preventDefault(); requestClose(); }); // Esc / Android back
    box.addEventListener('close', function () {
      // Closed by the browser itself: drop our history entry too
      if (historyPushed) { historyPushed = false; history.back(); }
      cleanup();
    });
    box.querySelector('[data-mrv-viewer-close]').addEventListener('click', requestClose);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1, 1); });

    // Open from the gallery: a tap (not a swipe) on an image, touch devices only
    el.addEventListener('click', function (e) {
      if (!isTouch.matches) return;
      var frame = e.target.closest('[data-zoom-src]');
      if (!frame || !el.contains(frame)) return;
      var slide = frame.closest('[data-mrv-slide]');
      open(parseInt(slide.getAttribute('data-image-index'), 10));
    });

    function point(e) {
      var r = stageRect();
      return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 };
    }
    function ids() { return Object.keys(pointers); }

    function startGesture() {
      var list = ids().map(function (k) { return pointers[k]; });
      if (list.length >= 2) {
        var a = list[0], b = list[1];
        gesture = {
          type: 'pinch',
          dist: Math.hypot(a.x - b.x, a.y - b.y) || 1,
          mid: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 },
          view: { s: view.s, x: view.x, y: view.y }
        };
      } else if (list.length === 1) {
        gesture = {
          type: view.s > 1.01 ? 'pan' : 'swipe',
          start: { x: list[0].x, y: list[0].y },
          view: { s: view.s, x: view.x, y: view.y },
          time: Date.now(),
          moved: false
        };
      }
    }

    stage.addEventListener('pointerdown', function (e) {
      if (!box.open) return;
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* pointer already released */ }
      pointers[e.pointerId] = point(e);
      items[current].classList.remove('is-animating');
      startGesture();
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId] || !gesture) return;
      pointers[e.pointerId] = point(e);
      var list = ids().map(function (k) { return pointers[k]; });

      if (gesture.type === 'pinch' && list.length >= 2) {
        var a = list[0], b = list[1];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        var mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        var s = Math.max(0.8, Math.min(MAX_SCALE * 1.2, gesture.view.s * (dist / gesture.dist)));
        // Zoom around the pinch start point, then follow the fingers' midpoint
        view.x = gesture.mid.x - (gesture.mid.x - gesture.view.x) * (s / gesture.view.s) + (mid.x - gesture.mid.x);
        view.y = gesture.mid.y - (gesture.mid.y - gesture.view.y) * (s / gesture.view.s) + (mid.y - gesture.mid.y);
        view.s = s;
        apply(false);
        return;
      }

      var p = list[0];
      var dx = p.x - gesture.start.x;
      var dy = p.y - gesture.start.y;
      if (!gesture.moved && Math.hypot(dx, dy) > 8) gesture.moved = true;
      if (!gesture.moved) return;

      if (gesture.type === 'pan') {
        view.x = gesture.view.x + dx;
        view.y = gesture.view.y + dy;
        clamp();
        apply(false);
      } else if (gesture.type === 'swipe') {
        // Resist at the first / last image
        var edge = (current === 0 && dx > 0) || (current === items.length - 1 && dx < 0);
        items[current].style.transform = 'translateX(' + (edge ? dx / 3 : dx) + 'px)';
      }
    });

    function endPointer(e) {
      if (!pointers[e.pointerId]) return;
      var endPoint = pointers[e.pointerId];
      delete pointers[e.pointerId];
      var remaining = ids().length;
      var g = gesture;

      if (remaining > 0) { startGesture(); return; } // e.g. one finger left after a pinch: pan
      gesture = null;
      // Last finger up: settle the zoom within 1x..MAX_SCALE (fingers often lift one at a time,
      // so a pinch can end as a pan)
      if (view.s < 1 || view.s > MAX_SCALE) {
        if (view.s < 1) view = { s: 1, x: 0, y: 0 };
        else zoomAt(MAX_SCALE, 0, 0);
        clamp();
        apply(true);
        return;
      }
      if (!g || g.type === 'pinch') { clamp(); apply(true); return; }

      if (g.type === 'swipe' && g.moved) {
        var dx = endPoint.x - g.start.x;
        var width = stageRect().width || 1;
        var fast = Math.abs(dx) / Math.max(1, Date.now() - g.time) > 0.5;
        if (e.type === 'pointerup' && (Math.abs(dx) > width * 0.2 || fast)) {
          if (dx < 0 && current < items.length - 1) { show(current + 1, 1); return; }
          if (dx > 0 && current > 0) { show(current - 1, -1); return; }
        }
        var item = items[current];
        item.classList.add('is-animating');
        item.style.transform = '';
        return;
      }

      // Double tap: zoom in at the tap point, or back out
      if (!g.moved && e.type === 'pointerup') {
        var now = Date.now();
        if (lastTap && now - lastTap.time < 300 && Math.hypot(endPoint.x - lastTap.x, endPoint.y - lastTap.y) < 30) {
          if (view.s > 1.01) view = { s: 1, x: 0, y: 0 };
          else { zoomAt(DOUBLE_TAP_SCALE, endPoint.x, endPoint.y); clamp(); }
          apply(true);
          lastTap = null;
        } else {
          lastTap = { time: now, x: endPoint.x, y: endPoint.y };
        }
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    el._mrvViewer = { open: open, close: requestClose, state: function () { return { index: current, s: view.s, x: view.x, y: view.y, open: box.open }; } };
  }

  window.MrvGallery = { init: init };
  Array.prototype.forEach.call(document.querySelectorAll('mrv-gallery'), init);
})();